/** Default wait for a screen's data before the loader gives up and shows its error box. */
export const LOAD_TIMEOUT_MS = 15_000;

/**
 * Settles with `promise`, or rejects after `ms` so a request that never answers
 * cannot leave a screen on "Loading…" forever.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number = LOAD_TIMEOUT_MS, what = 'The request'): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(`${what} took too long to answer.`)), ms);
    promise.then(
      value => { clearTimeout(timer); resolve(value); },
      error => { clearTimeout(timer); reject(error); },
    );
  });
}
